import { useParams } from 'react-router-dom'
import HeaderBCP from './header-bcp'
import Header from './header'
import { listChannelBCP } from 'domains/new-quotation/utils/getChannelNotNiubiz'

const HeaderForChannel = () => {
    const { channel = '' } = useParams()
    const Component = listChannelBCP[channel] ? HeaderBCP : Header;
    return <Component />
}

export default HeaderForChannel
